import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

/**
 * @description 判斷當前遊戲類型是否達到贏取上限
 * @returns
 */
const useCurrentGameTypeAchieveWinLImit = () => {
  const memberData = useSelector((state) => state.isMemberInfo);

  const { profit_data } = memberData || {};

  const { game_type } = useSelector((state) => state.isGameConfig) || {};

  const location = useLocation();

  const isGameBox = useMemo(() => {
    return location.pathname.includes("gamebox");
  }, [location.pathname]);

  const currentGameTypeAchieveWinLimit = useMemo(() => {
    if (isGameBox && profit_data && game_type) {
      return profit_data[game_type]?.lock === 1;
    }
    return false;
  }, [isGameBox, profit_data, game_type]);

  return currentGameTypeAchieveWinLimit;
};

export default useCurrentGameTypeAchieveWinLImit;
